import React from "react";

/**
 * About Page component for the `/about` route
 */
export default function About() {
    return (
        <main className="about-page">
            <h1 className="about-page__title">About Astro Data Colors</h1>
            <p className="about-page__introduction">
                Welcome to Astro Data Colors! This application lets you create a data visualization of near-Earth objects and gives you the option to mint your data visualizations as NFTs on the Solana blockchain or download it as a file.
            </p>
            <p>
                By making this generative visualization available for people to download as a file and/or to mint the info to the blockchain, I hope to provide not just a creative / generative experience that anyone can access but also provide the educational possibility for people to experience how blockchain and nfts can be created and used.
            </p>

            <section className="about-page__section">
                <h2 className="about-page__section-title">How It Works</h2>
                <ul className="about-page__list">
                    <li className="about-page__list-item">Select a date to fetch asteroid close-approach data.</li>
                    <li className="about-page__list-item">Preview the generated PNG visualization.</li>
                    <li className="about-page__list-item">Asteroid colors are randomly chosen from a color library/palette.</li>
                    <li className="about-page__list-item">Select the background color and outline color.</li>
                    <li className="about-page__list-item">Download the image and/or dataset for that day.</li>
                    <li className="about-page__list-item">Connect your wallet and mint the artwork as an NFT and save the data to the Solana blockchain and collect the artwork for your collection.</li>

                </ul>
            </section>

            <section className="about-page__section">
                <h2 className="about-page__section-title">Data Source</h2>
                <p className="about-page__section-text">
                    All asteroid data is provided by NASA’s Near Earth Object Web Service (NeoWs) API.
                </p>
                <p>
                    <a href="https://data.nasa.gov/dataset/asteroids-neows-api" target="_blank" rel="noopener noreferrer">NASA - Near Earth Object Web Service API</a>
                </p>
                <p>
                    <a href="https://api.nasa.gov/" target="_blank" rel="noopener noreferrer">NASA API Portal</a>
                </p>


            </section>
        </main>
    );
}